<template>

  <div>
    <v-navigation-drawer
        v-model="drawer"
        app
        class="d-md-none"
        v-if="this.$route.name !== 'dashboard-found' && this.$route.name !== 'found' && this.$route.name !== 'sign-up-promo' && this.$route.name !== 'sign-up-lowdefest'"
    >


      <v-divider></v-divider>

      <v-list dense nav>
        <v-list-item @click="navigate('home')">
          <v-list-item-action>
            <v-icon>home</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ $t('menu.Home') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item @click="navigate('products')" v-if="userIsOrganisation === false">
          <v-list-item-action>
            <v-icon>storefront</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Members shop</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item @click="navigate('our-story')">
          <v-list-item-action>
            <v-icon>info</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ $t('headings.Our story') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
<!--        <v-list-item @click="navigate('how-it-works')">-->
<!--          <v-list-item-action>-->
<!--            <v-icon>info</v-icon>-->
<!--          </v-list-item-action>-->
<!--          <v-list-item-content>-->
<!--            <v-list-item-title>How it works</v-list-item-title>-->
<!--          </v-list-item-content>-->
<!--        </v-list-item>-->
        <v-list-item @click="navigate('organisations')">
          <v-list-item-action>
            <v-icon>mdi-handshake-outline</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Organisations</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item @click="navigate('dashboard')" v-if="userIsOrganisation === true">
          <v-list-item-action>
            <v-icon>mdi-monitor-dashboard</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ $t('menu.Dashboard') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item @click="navigate('activate')">
          <v-list-item-action>
            <v-icon>mdi-check-decagram</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Activate tags</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item @click="navigate('environment')">
          <v-list-item-action>
            <v-icon>mdi-leaf</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Our environment</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item @click="helpDialog = true">
          <v-list-item-action>
            <v-icon>mdi-lifebuoy</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Support</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item @click="navigate('account')" v-if="authenticated() === true && userIsOrganisation === false">
          <v-list-item-action>
            <v-icon>account_circle</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ $t('menu.Dashboard') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item @click="navigate('dashboard')" v-else-if="authenticated() === true && userIsOrganisation === true">
          <v-list-item-action>
            <v-icon>account_circle</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ $t('menu.Dashboard') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item @click="navigate('sign-up')" v-if="authenticated() === false">
          <v-list-item-action>
            <v-icon>account_circle</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Create Account</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item @click="navigate('login')" v-if="authenticated() === false">
          <v-list-item-action>
            <v-icon>mdi-login</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ $t('menu.Login') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item @click="navigate('logout')" v-if="authenticated() === true">
          <v-list-item-action>
            <v-icon>mdi-logout</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ $t('menu.Log out') }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar :height="$vuetify.breakpoint.smAndDown ? 100 : 150" elevation="0" color="white">

      <v-app-bar-nav-icon v-if="this.$route.name !== 'dashboard-found' && this.$route.name !== 'found' && this.$route.name !== 'sign-up-promo'" @click.stop="drawer = !drawer" class="d-md-none"></v-app-bar-nav-icon>

      <v-toolbar-items style="width: 100%; position: relative" class="d-flex flex-column justify-center align-center">
        <div class="d-none d-md-block" style="position: absolute; top: 0; right: 0">
          <div v-if="authenticated() === false" class="d-flex flex-row mt-10" style="width: auto">
            <router-link
                :to="{ name: 'login' }"
                exact
                v-if="authenticated() === false"
                class="d-block"
            >
              {{ $t('menu.Login') }}
            </router-link>
            <router-link
                :to="{ name: 'sign-up' }"
                exact
                v-if="authenticated() === false"
                class="d-block"
            >
              Create Account
            </router-link>
          </div>
          <div v-else-if="authenticated()" class="d-flex flex-row justify-space-between mt-10" style="width: auto">

            <v-menu
                v-if="userIsOrganisation === false"
                v-model="basket.popover"
                :open-on-hover="false"
                :close-on-content-click="false"
                :nudge-width="100"
                offset-y

            >
              <template v-slot:activator="{ on }">
                <v-badge
                    color="black"
                    left
                    class="basket-badge"
                    :content="basketTotal"
                    offset-x="0"
                    offset-y="20"
                >
                  <v-btn
                      icon
                      :small="basketButtonSize"
                      v-on="on"
                      @click="navigate('basket')"
                  >
                    <v-icon
                        size="40"
                        color="black"
                    >shopping_cart</v-icon>
                  </v-btn>

                </v-badge>

              </template>

              <v-card>

                <Basket />

                <div class="pa-4">
                  <v-btn
                      rounded
                      block
                      elevation="0"
                      @click="closeBasket"
                  >
                    {{ $t('buttons.Close') }}
                  </v-btn>
                </div>


              </v-card>


            </v-menu>

            <v-menu bottom offset-y open-on-hover>
              <template v-slot:activator="{ on }">
                <v-btn
                    icon
                    v-on="on"
                >
                  <v-icon dense size="40" color="black">person</v-icon>
                </v-btn>
              </template>

              <v-list>
                <v-list-item
                    v-if="userIsOrganisation === true"
                >
                  <v-list-item-title>
                    <router-link
                        :to="{ name: 'dashboard' }"
                        exact
                    >
                      {{ $t('menu.Dashboard') }}
                    </router-link>
                  </v-list-item-title>

                </v-list-item>
                <v-list-item v-else>
                  <v-list-item-title>
                    <router-link
                        :to="{ name: 'account' }"
                        exact
                    >
                      {{ $t('menu.Dashboard') }}
                    </router-link>
                  </v-list-item-title>

                </v-list-item>
                <v-list-item>
                  <v-list-item-title>
                    <router-link
                        :to="{ name: 'logout' }"
                        exact
                    >
                      {{ $t('menu.Logout') }}
                    </router-link>
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
        </div>
        <div class="mt-3 mb-3">
          <router-link
              :to="{ name: 'home' }"
              exact
              style="padding: 0 !important;"
          >
            <v-img
                :src="logo"
                contain
                :width="logoWidth"
                style="margin-top: 0px"
                :alt="'Findmykit - ' + $t('A revolutionary way to find what\'s yours')"
            ></v-img>
          </router-link>
        </div>
        <div class="d-none d-md-flex align-center ma-0">
          <router-link
              :to="{ name: 'home' }"
              exact
              class="main-menu"
          >
            {{ $t('menu.Home') }}
          </router-link>
          <router-link
              :to="{ name: 'our-story' }"
              exact
              class="main-menu"
          >
            Our story
          </router-link>
<!--          <router-link-->
<!--              :to="{ name: 'how-it-works' }"-->
<!--              exact-->
<!--              class="main-menu"-->
<!--          >-->
<!--            How it works-->
<!--          </router-link>-->
          <router-link
              :to="{ name: 'organisations' }"
              exact
              class="main-menu"
          >
            Organisations
          </router-link>
          <router-link
              :to="{ name: 'products' }"
              exact
              class="main-menu"
          >
            Members shop
          </router-link>
          <router-link
              :to="{ name: 'activate' }"
              exact
              class="main-menu"
          >
            Activate tags
          </router-link>
          <router-link
              :to="{ name: 'environment' }"
              exact
              class="main-menu environment"
          >
            Our environment
          </router-link>
          <span @click="helpDialog = true" class="menu-link">Support</span>
        </div>

      </v-toolbar-items>

    </v-app-bar>

    <v-dialog max-width="600" v-model="helpDialog" rounded>
      <v-card>
        <v-card-title class="text-h5">
          Need a hand? We’ve got you covered!
        </v-card-title>

        <v-card-text>
          <p>To find answers to frequently asked questions in our searchable Help Centre, to request assistance from <strong><i>Kit</i></strong> our virtual assistant, or to request support from a member of our team, please use our support widget located at the bottom right of this page.</p>
        </v-card-text>

        <v-card-actions class="pb-6">
          <v-spacer></v-spacer>
          <v-btn
              color="primary"
              rounded
              @click="openChatWidget"
          >
            okay, I got that
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-divider></v-divider>
  </div>

</template>

<script>

    import { store } from '../store';
    import Basket from './Basket';
    import { mapState } from 'vuex'
    import {i18n} from "../i18n";

    let logo = require('@/assets/fmk-no-strap.png')

    import { mapActions } from 'vuex';



    export default {
        name: "Menu",
        components: {
          Basket
        },
        props: ['offset'],
        data: () => ({
            helpDialog: false,
            drawer: false,
            on: true,
            extended: false,
            extendedSlot: true,
            prominent: false,
            dense: false,
            collapse: false,
            flat: false,
            bg: false,
            extensionHeight: 48,
            logo: logo
        }),
        methods: {
            ...mapActions('account', ['switchRole']),
            ...mapActions('basket', ['closeBasket']),
            openChatWidget() {
              this.helpDialog = false
              if (window.fcWidget.isOpen() !== true) {
                window.fcWidget.open();
              }
            },
            onChangeLocale(event) {
              i18n.locale = event

              // if (event === 'es') {
              //   this.$vuetify.theme.dark = true
              // }
              // else {
              //   this.$vuetify.theme.dark = false
              // }

              store.dispatch('setLocale', event, {root: true}).then(() => {
                //
              })
            },
            languageCodeFromLocale(locale) {
              if (locale === 'en') {
                return 'gb'
              }
              else {
                return locale
              }
            },
            navigate (routeName) {
                this.$router.push({name: routeName})
            },
            adminFor () {
                let user = this.user;
                if (user && user.roles && store.getters['account/isAdmin']) {
                    return 'For ' + user.admin_for_organisations[0].name
                }
            },
            authenticated () {
                return store.state.authenticated
            },
            switchAdmin () {
                return this.switchRole().then(() => {
                    console.log('switch')
                })
            }
        },
        computed: {
            ...mapState({
                user: state => state.account.user,
                adminForOrganisations: state => state.account.user.admin_for_organisations,
                basket: state => state.basket,
                usersName: state => state.account.user.name,
                organisationSlug: state => state.referringOrganisation,
                brand: state => state.brand,
                brandName: state => state.brandName
            }),
            logoWidth() {
              if (window.innerWidth < 600) {
                return 280
              }
              else {
                return 400
              }
            },
            languageArray() {
              console.log(i18n.locale)
              return [
                {
                  name: i18n.t('messages.English'),
                  lang: 'en'
                },
                {
                  name: i18n.t('messages.Spanish'),
                  lang: 'es'
                }
              ]
            },
            admin: {
                get: () => store.getters['account/isAdmin'],
                set: () => console.log('dummy setter')
            },
            basketButtonSize () {
                if (this.$vuetify.breakpoint.name === 'xs') {
                    return true
                }

                return false
            },
            appBarHeight () {
                if (this.$vuetify.breakpoint.name === 'xs') {
                    return 80
                }

                return 120
            },
            basketTotal () {
                return store.getters['basket/productsCount']
            },
            userIsOrganisation() {
                return store.getters.userHasRole(['organisation'])
            },
            adminForOrganisation() {
                let user = this.user;
                if (user && user.admin_for_organisations) {
                    return user.admin_for_organisations[0].name
                }
                return null
            },
            userRoles () {
                let user = this.user;
                if (user && user.roles) {
                    return user.roles
                }
                return [];
            }
        }
    }
</script>

<style scoped>
    .v-application header a, .v-application header .dropdown {
      padding: 5px 15px !important;
    }
    .brand-pink {
        color: #cd0059
    }
    .fixed-image .v-image__image--contain {
        position: fixed !important;
        background-position: left !important;
        max-width: 350px;
    }
    .v-application .account-block .router-link-active {
      color: var(--v-textOnPrimary-base);
    }
    .logged-out-block {
      background-color: var(--v-primary-base);
      /*height: 50px;*/
      padding: 5px;
      margin-left: 20px;
      margin-right: -16px;
      min-width: 275px;
    }
    .logged-out-block.small {
      margin-left: 0;
      min-width: 150px;
    }
    .logged-out-block.logged-out-block-xs.small {
      /*height: 40px;*/
      min-width: 110px;
    }
    .logged-out-block.logged-out-block-xs.small a {
      font-size: 12px;
      padding: 5px !important;
    }
    .logged-out-block.logged-out-block-xs.small .basket-badge {
      font-size: 14px;
      min-width: 100px;
    }
    .v-application header .logged-out-block a:hover {
      color: black;
    }
    .logged-in-block {
        background-color: var(--v-primary-base);
        height: 50px;
        padding: 5px;
        margin-left: 20px;
        margin-right: -16px;
        min-width: 275px;
    }
    .logged-in-block.small {
        margin-left: 0;
        min-width: 210px;
    }
    .logged-in-block.logged-in-block-xs.small {
        height: 40px;
        min-width: 210px;
    }
    .logged-in-block.logged-in-block-xs.small a {
        font-size: 16px;
        padding: 5px;
    }
    .logged-in-block.logged-in-block-xs.small .basket-badge {
        font-size: 14px;
        min-width: 50px;
    }
    .logged-in-as-block {
        height: 50px;
        padding: 5px;
        margin-left: 20px;
        margin-right: -16px;
        min-width: 275px;
        line-height: 1.4em;
    }
    .logged-in-as-block.small {
        margin-left: 0;
        min-width: 210px;
        line-height: 1.1em;
    }
    .basket-badge {
        margin-left: 10px;
        font-size: 18px;
        font-weight: bold;
        min-width: 50px;
    }
    .divider {
        border-color: #fff;
    }
    .app-bar {
        z-index: 2;
    }
    .app-bar-small {
        height: 70px;
    }
    .v-toolbar.v-toolbar--absolute {
        z-index: 3 !important;
    }
    button, .v-tab {
        text-transform: none;
        font-family: 'Lato', sans-serif;
        font-weight: bold;
    }
    .v-application .router-link-active,
    .v-application .router-link-active.environment {
        color: var(--v-primary-base);
    }
    .v-application .environment {
      color: #388E3C;
    }
    .v-application header a, .v-application header .dropdown {
        color: var(--v-menuText-base);
        padding: 15px 15px;
        font-weight: normal;
        font-size: 18px;
        font-family: "Open Sans", sans-serif;
        font-optical-sizing: auto;
    }
    .v-application a:hover, .v-application header .dropdown:hover {
        text-decoration: none;
    }
    .v-application a.main-menu:hover, .v-application .dropdown:hover {
        /*background-color: var(--v-menuBackground-base);*/
    }
    .v-application header .logged-in-block a {
        color: #fff;
    }
    .v-application header .logged-in-block a:hover {
        color: #000;
    }
    .v-toolbar__items > .v-btn {
        height: auto !important;
    }
    .v-toolbar__title.toolbar-title-xs {
        padding-left: 0 !important;
    }
    .login-button.v-btn {
      /*border-radius: 15px;*/
      /*height: 56px !important;*/
      /*padding-left: 20px !important;*/
      /*padding-right: 20px !important;*/
      /*text-transform: none !important;*/
    }

</style>

<style>
  .select-flag img:not(.md-image) {
    height: 30px !important;
  }

  .chosen-flag {
    width: 50px;
    max-height: 60px;
  }

  .menu-link {
    font-family: "Open Sans", sans-serif !important;
    font-size: 18px !important;
    font-weight: normal !important;
    color: var(--v-menuText-base) !important;
    letter-spacing: 0.14px;
    padding: 5px 15px !important;
  }
  .menu-link:hover {
    cursor: pointer;
  }
</style>
